<template>
    <div class="page">
        <div class="head-title">
            <div class="left">
                <ul class="breadcrumb">
                    <li>
                        <a href="#">{{ $t("management") }} {{ $t("projects") }}</a>
                    </li>
                    <li>-</li>
                    <li>
                        <a class="active" href="#">{{ $t("all") }} {{ $t("extracts") }}</a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="main">
            <div class="head">
                <div class="head1">
                    <h3>{{ $t("extracts") }}</h3>
                    <input type="text" :placeholder="$t('name')" v-model="name" />
                    <input type="text" :placeholder="$t('code')" v-model="code" />
                    <input type="text" :placeholder="$t('contractor')" v-model="contractor" />
                    <input type="text" :placeholder="$t('code') + $t('contract')" v-model="codecontract" />
                    <input type="text" :placeholder="$t('project')" v-model="codeproject" />
                    <input type="date" :placeholder="$t('from')" v-model="datefrom" />
                    <input type="date" :placeholder="$t('to')" v-model="dateto" />
                    <select name="" id="" v-model="status" style="border: none;">
                        <option value="%">{{ $t("all") }}</option>
                        <option value="waiting">{{ $t("waiting") }}</option>
                        <option value="confirmed">{{ $t("confirmed") }}</option>
                        <option value="deleted">{{ $t("deleted") }}</option>
                    </select>
                    <button style="padding: 1%" @click="search()">
                        {{ $t("search") }}
                    </button>
                </div>
                <div class="head2">
                    <!-- <button>
                        <router-link to="/ProjectsManagement/AllExtracts/CreateExtract" class="btn-download">
                            <span class="text">
                                <i class="bi bi-clipboard-plus-fill"></i>
                                {{ $t("add") }} {{ $t("extract") }}
                            </span>
                        </router-link>
                    </button> -->
                    <button @click="exportToExcel()">Excel</button>
                </div>
            </div>
            <div class="body">
                <div>
                    <table-lite :is-static-mode="false" :is-slot-mode="true" :is-loading="table.isLoading"
                        :columns="table.columns" :rows="table.rows" :total="table.totalRecordCount"
                        :sortable="table.sortable" :page-size="pageSize" v-model:current-page="currentPage"
                        @row-delete="rowDelete" @row-edite="editExtract" @row-view="InvoiceView" @do-search="doSearch">
                        <template v-slot:quick="slotProps">
                            <button class="btn btn-light view-btn" @click.prevent="InvoiceView(slotProps.value)">
                                <i class="bi bi-search"></i>
                            </button>
                            <!-- <button class="btn btn-light edit-btn" @click.prevent="editExtract(slotProps.value)">
                                <i class="bi bi-pencil-square"></i>
                            </button> -->
                            <!-- <button v-if="hasPermission('project_delete_invoices')" class="btn btn-light delete-btn" @click.prevent="rowDelete(slotProps.value)">
                                <i class="bi bi-trash"></i>
                            </button> -->
                        </template>
                    </table-lite>
                </div>
            </div>
        </div>
    </div>
</template>

  <script>
import { reactive } from "vue";
import { useRouter, useRoute } from "vue-router";
import TableLite from "../../../components/TableLite.vue";
import axios from "axios";
import Swal from "sweetalert2";
import { mapActions } from "vuex";
import * as XLSX from "xlsx";

export default {
  title: "Extracts",
  props: ["css"],
  components: { TableLite },
  data() {
    return {
      name: "",
      code: "",
      contractor: "",
      codecontract: "",
      codeproject: "",
      status: "%",
      datefrom: "",
      dateto: "",
      pageSize: 50,
      currentPage: 1,
    };
  },
  mounted() {
    // Initialize filters from query parameters
    const route = useRoute();
    this.name = route.query.name ? String(route.query.name) : "";
    this.code = route.query.id ? String(route.query.id) : "";
    this.contractor = route.query.contractor ? String(route.query.contractor) : "";
    this.codecontract = route.query.codecontract ? String(route.query.codecontract) : "";
    this.codeproject = route.query.project ? String(route.query.project) : "";
    this.status = route.query.status ? String(route.query.status) : "%";
    this.datefrom = route.query.datefrom ? String(route.query.datefrom) : "";
    this.dateto = route.query.dateto ? String(route.query.dateto) : "";
    this.currentPage = route.query.page ? parseInt(route.query.page, 10) || 1 : 1;
    this.pageSize = route.query.limit ? parseInt(route.query.limit, 10) || 50 : 50;

    // Trigger initial search with query parameters
    this.doSearch(
      (this.currentPage - 1) * this.pageSize,
      this.pageSize,
      route.query.order || "id",
      route.query.sort || "desc"
    );
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const table = reactive({
      columns: [
        {
          label: "code",
          field: "cid",
          width: "1%",
          text: "EXT-",
          sortable: true,
          isKey: true,
          headerClasses: ["bg-gold", "color-red"],
          columnClasses: ["bg-gray"],
        },
        {
          label: "name",
          field: "name",
          width: "15%",
          sortable: true,
        },
        {
          label: "project",
          field: "project",
          width: "15%",
          sortable: true,
        },
        {
          label: "contractor",
          field: "contractorname",
          width: "15%",
          sortable: true,
        },
        {
          label: "amount",
          field: "amount",
          width: "10%",
          sortable: true,
        },
        {
          label: "date",
          field: "date",
          width: "10%",
          sortable: true,
        },
        {
          label: "time",
          field: "time",
          width: "10%",
          sortable: true,
        },
        {
          label: "status",
          field: "status",
          width: "10%",
          sortable: true,
        },
        {
          label: "option",
          field: "quick",
          width: "10%",
        },
      ],
      rows: [],
      totalRecordCount: 0,
      sortable: {
        order: "id",
        sort: "desc",
      },
      isLoading: false,
    });

    const rowDelete = async (row) => {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const del = await axios.delete(`/projects/delextractcontract/${row.cid}`);
            if (del.status === 200) {
              const indexOfObject = table.rows.findIndex((object) => {
                return object.cid === row.cid;
              });
              table.rows.splice(indexOfObject, 1);
              table.totalRecordCount--;
              Swal.fire("Deleted!", "Your file has been deleted.", "success");
            }
          } catch (error) {
            Swal.fire("Error!", "Failed to delete the extract.", "error");
            console.error("Delete error:", error);
          }
        }
      });
    };

    const editExtract = (row) => {
      // Preserve query parameters when navigating to edit
      router.push({
        path: `/ProjectsManagement/AllExtracts/EditExtract/${row.cid}`,
        query: route.query,
      });
    };

    const InvoiceView = (row) => {
      // Preserve query parameters when navigating to view
      router.push({
        path: `/customerDashboard/project/extractview/${row.cid}`,
        query: { ...route.query, id: row.id },
      });
    };

    // const doSearch = async function (offset, limit, order, sort) {
    //   table.isLoading = true;
    //   try {
    //   console.log(this);
    //     const params = {
    //       id: this.code || undefined,
    //       datefrom: this.datefrom || undefined,
    //       dateto: this.dateto || undefined,
    //       name: this.name || undefined,
    //       contractor: this.contractor || undefined,
    //       codecontract: this.codecontract || undefined,
    //       project: this.codeproject || undefined,
    //       status: this.status !== "%" ? this.status : undefined,
    //       page: Math.floor(offset / limit) + 1,
    //       limit,
    //       order,
    //       sort,
    //     };
    //     console.log("doSearch params:", params);
    //     const response = await axios.get("/projects/allextracts", { params });
    //     table.rows = response.data.data;
    //     table.totalRecordCount = response.data.total;
    //     table.sortable.order = order;
    //     table.sortable.sort = sort;
    //   } catch (error) {
    //     console.error("doSearch error:", error);
    //     Swal.fire("Error!", "Failed to fetch extracts.", "error");
    //   } finally {
    //     table.isLoading = false;
    //   }
    // };

    return {
      table,
      rowDelete,
      editExtract,
      InvoiceView,
    //   doSearch,
    };
  },
  methods: {
    async doSearch(offset, limit, order, sort) {
      this.table.isLoading = true;
      try {
        const params = {
          id: this.code || undefined,
          datefrom: this.datefrom || undefined,
          dateto: this.dateto || undefined,
          name: this.name || undefined,
          contractor: this.contractor || undefined,
          codecontract: this.codecontract || undefined,
          project: this.codeproject || undefined,
          status: this.status !== "%" ? this.status : undefined,
          page: Math.floor(offset / limit) + 1,
          limit,
          order,
          sort,
        };

        console.log("doSearch params:", params);
        const response = await axios.get("/owner-dashboard/allextracts", { params });
        this.table.rows = response.data.data;
        this.table.totalRecordCount = response.data.total;
        this.table.sortable.order = order;
        this.table.sortable.sort = sort;
      } catch (error) {
        console.error("doSearch error:", error);
        Swal.fire("Error!", "Failed to fetch extracts.", "error");
      } finally {
        this.table.isLoading = false;
      }
    },
    async search() {
      this.table.isLoading = true;
      try {
        // Update URL with filter parameters
        await this.$router.push({
          path: "/customerDashboard/project/AllExtractsPayment",
          query: {
            id: this.code || undefined,
            datefrom: this.datefrom || undefined,
            dateto: this.dateto || undefined,
            name: this.name || undefined,
            contractor: this.contractor || undefined,
            codecontract: this.codecontract || undefined,
            project: this.codeproject || undefined,
            status: this.status !== "%" ? this.status : undefined,
            page: String(this.currentPage),
            limit: String(this.pageSize),
            order: this.table.sortable.order,
            sort: this.table.sortable.sort,
          },
        });

        const params = {
          id: this.code || undefined,
          datefrom: this.datefrom || undefined,
          dateto: this.dateto || undefined,
          name: this.name || undefined,
          contractor: this.contractor || undefined,
          codecontract: this.codecontract || undefined,
          project: this.codeproject || undefined,
          status: this.status !== "%" ? this.status : undefined,
          page: this.currentPage,
          limit: this.pageSize,
          order: this.table.sortable.order,
          sort: this.table.sortable.sort,
        };
        console.log("search params:", params);
        const action = await axios.get("/owner-dashboard/allextracts", { params });
        if (action.status === 200) {
          this.table.rows = action.data.data;
          this.table.totalRecordCount = action.data.total;
          this.currentPage = 1;
        }
      } catch (error) {
        console.error("Search error:", error);
        Swal.fire("Error!", "Failed to fetch extracts.", "error");
      } finally {
        this.table.isLoading = false;
      }
    },
    //   exportToExcel() {
    //     const data = this.table.rows.map((row) => ({
    //       رقم_المستخلص: row.cid,
    //       الاسم: row.name,
    //       المشروع: row.project,
    //       المقاول: row.contractorname,
    //       المبلغ_بدون_الضريبة: Number(row.amountwout),
    //       الضريبة: Number(row.amount - row.amountwout),
    //       المبلغ_الاجمالى: Number(row.amount),
    //       التاريخ: row.date,
    //       الحالة: row.status,
    //     }));
    //     const wb = XLSX.utils.book_new();
    //     const ws = XLSX.utils.json_to_sheet(data);
    //     XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    //     XLSX.writeFile(wb, `المستخلصات.xlsx`);
    //   },

    async exportToExcel() {
      try {
        this.table.isLoading = true;
        const params = {
          id: this.code || undefined,
          datefrom: this.datefrom || undefined,
          dateto: this.dateto || undefined,
          name: this.name || undefined,
          contractor: this.contractor || undefined,
          codecontract: this.codecontract || undefined,
          project: this.codeproject || undefined,
          status: this.status !== "%" ? this.status : undefined,
          order: this.table.sortable.order,
          sort: this.table.sortable.sort,
        };
        const response = await axios.get("/owner-dashboard/allextracts/export", { params });
        if (response.status === 200) {
          const data = response.data.data.map((row) => ({
            رقم_المستخلص: `EXT-${row.cid}`,
            الاسم: row.name,
            المشروع: row.project,
            المقاول: row.contractorname,
            المبلغ_بدون_الضريبة: Number(row.amountwout),
            الضريبة: Number(row.amount - row.amountwout),
            المبلغ_الاجمالى: Number(row.amount),
            التاريخ: row.date,
            الوقت: row.time,
            الحالة: row.status,
          }));
          const ws = XLSX.utils.json_to_sheet(data);
          const colWidths = [
            { wch: 15 }, // رقم_المستخلص
            { wch: 20 }, // الاسم
            { wch: 20 }, // المشروع
            { wch: 20 }, // المقاول
            { wch: 15 }, // المبلغ_بدون_الضريبة
            { wch: 15 }, // الضريبة
            { wch: 15 }, // المبلغ_الاجمالى
            { wch: 15 }, // التاريخ
            { wch: 15 }, // الوقت
            { wch: 15 }, // الحالة
          ];
          ws['!cols'] = colWidths;
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "Extracts");
          XLSX.writeFile(wb, `المستخلصات_${this.datefrom || 'all'}_${this.dateto || 'all'}.xlsx`);
        }
      } catch (error) {
        console.error("Export error:", error);
        Swal.fire("Error!", "Failed to export extracts.", "error");
      } finally {
        this.table.isLoading = false;
      }
    },
    ...mapActions(["redirectTo"]),
  },
  watch: {
    pageSize(newSize) {
      this.$router.push({
        query: {
          ...this.$route.query,
          limit: String(newSize),
          page: "1",
        },
      });
      this.doSearch(0, newSize, this.table.sortable.order, this.table.sortable.sort);
    },
    currentPage(newPage) {
      this.$router.push({
        query: {
          ...this.$route.query,
          page: String(newPage),
        },
      });
      this.doSearch(
        (newPage - 1) * this.pageSize,
        this.pageSize,
        this.table.sortable.order,
        this.table.sortable.sort
      );
    },
  },
};
  </script>

  <style lang="scss" scoped>
.page {
    direction: v-bind("css.EN");
    padding: 0.5%;
}

.main {
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    padding: 1%;
}

.body {
    padding: 1%;
}

.part {
    font-size: large;
    width: 99%;
    padding: 2%;
    margin: 0.5%;
    background-color: white;
    border-radius: 5px;
    color: black;
    display: flex;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.part .group {
    width: 50%;
}

.part img {
    width: 100%;
    height: 100px;
}

ul {
    text-decoration: none;
    list-style-type: none;
    color: black;
}

.bi {
    margin: 1%;
}

.head {
    padding: 0.25%;
    display: flex;
    border-bottom-style: ridge;
}

.head1 {
    width: 60%;
}

.head1 input {
    margin: 0.5%;
    padding: 0.5%;
    border: none;
    border-radius: 5px;
    background-color: #eee;
}

.head2 {
    width: 40%;
    text-align: center;
}

.head2 button {
    margin: 0.5%;
    padding: 1%;
    border: none;
    border-radius: 5px;
    background-color: rgba(98, 153, 174, 255);
    color: white;
    font-size: small;
    width: 30%;
}

.head2 button a {
    color: white;
}

button {
    margin: 0.5%;
    padding: 5%;
    border: none;
    border-radius: 5px;
    background-color: rgba(98, 153, 174, 255);
    color: white;
    font-size: small;
}

.view-btn,
.edit-btn,
.delete-btn {
    margin: 0 5px;
}
</style>
